<template>
	<div>
		<panel-basic title="Change my Password"
								id="passwordSettings"
								:collapsable="true"
								:headingLevel="4">
			<template slot="title">
				{{ $t('MAIN_CONTENT.General.changeMyPasswordForced') }}
			</template>
			<div class="alert"
					:class="{'alert-success': passwordFields.responseType === 'success', 'alert-danger': passwordFields.responseType === 'danger'}"
					v-if="!!passwordFields.responseMessage">
				{{ passwordFields.responseMessage }}
			</div>
			<div class="row">
				<!-- Emailed Password -->
				<div class="col-xs-6 col-md-4">
					<div class="row">
						<div class="col-xs-12">
							<strong>{{ $t('MAIN_CONTENT.General.oldPasswordStartCaseWithColon') }}</strong>
						</div>
						<div class="col-xs-12">
							<input type="password" class="form-control" v-model="passwordFields.oldPassword" maxlength="30">
						</div>
					</div>
				</div>
			</div>
			<br />
			<div class="row">
				<!-- New Password -->
				<div class="col-xs-6 col-md-4">
					<div class="row">
						<div class="col-xs-12">
							<strong>
								{{ $t('MAIN_CONTENT.General.newPasswordStartCaseWithColon') }}
							</strong>
						</div>
						<div class="col-xs-12 userWizard">
							<password
								name="password"
								ref="password" 
								class="password-input"
								v-model="passwordFields.newPassword"
								:toggle="true"
								:secureLength="passwordMinLegth"
								:showStrengthMeter="true"
								autocomplete="new-password"
								maxlength="40"
								:disabled="passwordFields.oldPassword.length <= 0"
							/>
						</div>
					</div>
				</div>
				<!-- Confirm New Password -->
				<div class="col-xs-6 col-md-4">
					<div class="row">
						<div class="col-xs-12">
							<strong>
								{{ $t('MAIN_CONTENT.General.confirmNewPasswordStartCaseWithColon') }}
							</strong>
						</div>
						<div class="col-xs-12 userWizard">
							<password
								name="password"
								ref="password" 
								class="password-input"
								v-model="passwordFields.confirmNewPassword"
								:toggle="true"
								:secureLength="passwordMinLegth"
								:showStrengthMeter="true"
								autocomplete="new-password"
								maxlength="40"
								:disabled="passwordFields.oldPassword.length <= 0"
							/>
							<small v-if="passwordFields.newPassword.length > 0 && passwordMessage > 0" class="help-block text-danger" >
								<span v-if="passwordMessage === 1">
									Password must must have the following characteristics: 
									<ul>
										<li>At least {{passwordMinLegth}} characters - the more characters, the better.</li>
										<li>A mixture of letters and numbers.</li>
									</ul>	
								</span>
								
								<span v-if="passwordMessage === 2">Confirm password does not match</span>
							</small>
						</div>
					</div>
				</div>
			</div>
			<br />
			<div class="row">
				<div class="col-xs-4 col-xs-offset-4">
					<button class="btn btn-default"
									@click="saveNewPassword"
									:disabled="passwordMessage !== 0">
						{{ $t('commonText.save') }}
					</button>
				</div>
			</div>
		</panel-basic>
	</div>
</template>

<script>
	import Profile from '../../api/Profile';
	import { mapGetters } from 'vuex';
	import PanelBasic from 'COMMONS/panels/PanelBasic.vue';
	import Password from 'vue-password-strength-meter'

	export default {
		data() {
			return {
				passwordFields: {
					oldPassword:'',
					newPassword: '',
					confirmNewPassword: '',
					responseType: '',
					responseMessage: ''
				},
				passwordMinLegth:8
			};
		},
		components: {
			PanelBasic, 
			Password
		},
		computed: {
			...mapGetters(['credType', 'userID','role']),
			allPasswordFields() {
				return this.passwordFields.newPassword + this.passwordFields.confirmNewPassword;
			},
			passwordMessage(){
				let alpha = /[a-zA-Z]/,
				number = /[0-9]/,
				minLength = this.passwordMinLegth;
				/* check length */
				if(this.passwordFields.newPassword.length < minLength){
					return 1;
				}
				/* Check A mixture of letters and numbers */
				else if(!alpha.test(this.passwordFields.newPassword) || !number.test(this.passwordFields.newPassword)){
					return 1;
				}
				/* Make sure confirm password matches */
				else if(this.passwordFields.newPassword !== this.passwordFields.confirmNewPassword){
					return 2;
				}
				/* else basic check password change is good */
				return 0;
			}
		},
		watch: {
			allPasswordFields(newValue, oldValue){
				if( oldValue === '' ){
					this.passwordFields.responseType = '';
					this.passwordFields.responseMessage = '';
				}
			}
		},
		methods: {
			resetPasswordFields(){
				this.passwordFields.newPassword = '';
				this.passwordFields.confirmNewPassword = '';
			},
			resetSecurityQuestionFields(){
				this.securityQuestionFields.answer = '';
			},
			saveNewPassword() {
				const self = this;

				let profile = new Profile({
					routeParams: { setting: 'password' },
					data: {
						'password': this.passwordFields.oldPassword,
						'new_password': this.passwordFields.newPassword,
						'new_password_confirm': this.passwordFields.confirmNewPassword,
						'user_id':this.userID,
						'pin':''
					}
				});

				const promise = profile.put();

				promise.then(response => {
					self.passwordFields.responseType = profile.getResponseData().TYPE;
					self.passwordFields.responseMessage = profile.getResponseData().TEXT;
					self.resetPasswordFields();

					if(this.passwordFields.responseType === 'success'){
						this.$store.dispatch('fetchProfile').then(()=>{
							this.goToHome();
						});
					}
				})
				.catch(error => {
					self.resetPasswordFields();
				});
			},
			goToHome(){
				if(this.role === 'parent') {
					if(this.$store.state.students.length > 1) {
						this.resetSelectedStudentRID();
					}

					this.$route.name === 'HomePage' ?
						this.$router.push({ name: 'ParentHome' }) :
						this.$router.push({ name: 'HomePage' });
				} else {
					this.$router.push({ name: 'HomePage' });
				}
			}
		},
		created() {
			this.$store.commit('setTitleIcon', '');
			this.$store.commit('setTitle', '');
			this.$store.commit('setUseHeader', false);
		}
	}
</script>
